import styled from 'styled-components';

export const Wrapper = styled.div`
  .text {
    color: var(--black);
    @media screen and (max-width: 576px) {
      font-size: 1.5rem;
    }
  }
`;
